module.exports = __webpack_public_path__ + "static/img/background.1781503650204.png";